<div>
  <h3 class="mt-2">{{ 'content.person.name' | translate }}</h3>
  <div class="row">
    <div class="col-md-3 col-sm-6">{{ 'content.person.first-name' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.firstName }}</div>
    }
    <div class="col-md-3 col-sm-6">{{ 'content.person.middle-name' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.middleName }}</div>
    }
    <div class="col-md-3 col-sm-6">{{ 'content.person.last-name' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.lastName }}</div>
    }
  </div>
  <h3 class="mt-2">{{ 'content.identification' | translate }}</h3>
  <div class="row">
    <div class="col-md-3 col-sm-6">{{ 'content.social-insurance-number' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.sin }}</div>
    }
    <div class="col-md-3 col-sm-6">{{ 'content.person.dob' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.dob }}</div>
    }
    <div class="col-md-3 col-sm-6">{{ 'content.card1' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">
        @if (!!cardTypes) {
          <div>
            @for (cardType of (cardTypes | keyvalue); track cardType) {
              <div>
                @if (cardType.key === profile.card) {
                  <div>
                    {{ cardType.value }}
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
    <div class="col-md-3 col-sm-6">{{ 'content.account-num' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.account }}</div>
    }
  </div>
  <h3 class="mt-2">{{ 'content.current-address' | translate }}</h3>
  <div class="row">
    <div class="col-md-3 col-sm-6">{{ 'content.address.street-num' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.streetNum }}</div>
    }
    <div class="col-md-3 col-sm-6">{{ 'content.address.street' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.street }}</div>
    }
    <div class="col-md-3 col-sm-6">{{ 'content.address.unit-apt' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.apartmentNum }}</div>
    }
    <div class="col-md-3 col-sm-6">{{ 'content.address.city' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.city }}</div>
    }
    <div class="col-md-3 col-sm-6">{{ 'content.address.province' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.province }}</div>
    }
    <div class="col-md-3 col-sm-6">{{ 'content.address.postal-code' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.postalCode }}</div>
    }
  </div>
  <h3 class="mt-2">{{ 'content.phone.phone' | translate }}</h3>
  <div class="row">
    <div class="col-md-3 col-sm-6">{{ 'content.number' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.phone }}</div>
    }
  </div>
  <h3 class="mt-2">{{ 'content.employment' | translate }}</h3>
  <div class="row">
    <div class="col-md-3 col-sm-6">{{ 'content.person.occupation' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.job }}</div>
    }
    <div class="col-md-3 col-sm-6">{{ 'content.employer' | translate }}:</div>
    @if (profile) {
      <div class="col-md-3 col-sm-6">{{ profile.employer }}</div>
    }
  </div>
  @if (profile && profile.inclPrevAddress) {
    <div>
      <h3 class="mt-2">{{ 'content.address.previous-address' | translate }}</h3>
      <div class="row">
        <div class="col-md-3 col-sm-6">{{ 'content.address.street-num' | translate }}:</div>
        <div class="col-md-3 col-sm-6">{{ profile.prevStreetNum }}</div>
        <div class="col-md-3 col-sm-6">{{ 'content.address.street' | translate }}:</div>
        <div class="col-md-3 col-sm-6">{{ profile.prevStreet }}</div>
        <div class="col-md-3 col-sm-6">{{ 'content.address.unit-apt' | translate }}:</div>
        <div class="col-md-3 col-sm-6">{{ profile.prevApartmentNum }}</div>
        <div class="col-md-3 col-sm-6">{{ 'content.address.city' | translate }}:</div>
        <div class="col-md-3 col-sm-6">{{ profile.prevCity }}</div>
        <div class="col-md-3 col-sm-6">{{ 'content.address.province' | translate }}:</div>
        <div class="col-md-3 col-sm-6">{{ profile.prevProvince }}</div>
        <div class="col-md-3 col-sm-6">{{ 'content.address.postal-code' | translate }}:</div>
        <div class="col-md-3 col-sm-6">{{ profile.prevPostalCode }}</div>
      </div>
    </div>
  }
</div>
